import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-communication-email',
  templateUrl: './communication-email.component.html',
  styleUrls: ['./communication-email.component.scss']
})
export class CommunicationEmailComponent implements OnInit {

  @Input() email;

  constructor() { }

  ngOnInit() {
  }

}
